import React from 'react';
import { componentsRedux } from 'redux/reusable';
import { usePowerSubQuerys } from 'apollo/power';

const Subqueries = (props) => {
  const { yearStart, yearEnd, weekStart, weekEnd } = props;
  const { data, loading } = usePowerSubQuerys({
    yearStart,
    yearEnd,
    weekStart,
    weekEnd,
  });
  return <>{props.children({ loading, data: data.Subqueries })}</>;
};

export default componentsRedux(Subqueries);
